import Link from 'next/link';
import Image from 'next/legacy/image';
import { SimpleHeaderProps } from 'types';
import { CommentedLink } from 'components/CommentedLink/CommentedLink';

import styles from './SimpleHeader.module.scss';

export const SimpleHeader = ({ caption, linkCaption, linkHref, linkId }: SimpleHeaderProps) => {
  return (
    <div className={styles.header}>
      <Link href="/" legacyBehavior={true}>
        <a href="#">
          <Image src="/icons/logo.svg" width={150} height={24} alt="SENDY" />
        </a>
      </Link>
      <div className={styles.headerDesktop}>
        <CommentedLink caption={caption} linkId={linkId} linkHref={linkHref} linkCaption={linkCaption} />
      </div>
    </div>
  );
};
